import { cn } from '../lib/utils'

/**
 * Объём кнопок низа урока — как в плеере (academy-frontend `CtaButton.module.css`,
 * `BackButton .pressable`): пилюля стоит на 6px-кромке цвета `--cta-ink` с
 * мягким свечением `--cta-glow`, при нажатии садится на кромку; светлый кант
 * 2px у верха гаснет к середине (`::after`). Цвета задаёт кнопка
 * CSS-переменными — тень в классе, а не в инлайн-стиле, иначе `:active` её не
 * перебьёт.
 */
export const PRESSABLE_CLASS = cn(
  'relative isolate overflow-hidden rounded-full transition-[transform,box-shadow] duration-100 ease-out',
  'shadow-[0_6px_0_0_var(--cta-ink),0_12px_22px_color-mix(in_srgb,var(--cta-glow)_35%,transparent)]',
  'enabled:active:translate-y-[6px] enabled:active:shadow-[inset_0_1px_0_rgba(255,255,255,0.5)]',
  "after:pointer-events-none after:absolute after:inset-0 after:rounded-[inherit] after:p-[2px] after:content-['']",
  'after:[background:linear-gradient(180deg,rgb(255_255_255/0.7),rgb(255_255_255/0)_60%)]',
  // Оператор `exclude` — внутри шортката `mask`: отдельный `mask-composite`
  // Tailwind кладёт ДО шортката, тот его сбрасывает, и кант разливался
  // белым градиентом на всю верхнюю треть кнопки.
  'after:[mask:linear-gradient(#000_0_0)_content-box_exclude,linear-gradient(#000_0_0)]',
)
